import { render } from "./component-adress.vue?vue&type=template&id=33000a63"
import script from "./component-adress.vue?vue&type=script&setup=true&lang=js"
export * from "./component-adress.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-adress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33000a63"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33000a63', __exports__)) {
    api.reload('33000a63', __exports__)
  }
  
  module.hot.accept("./component-adress.vue?vue&type=template&id=33000a63", () => {
    api.rerender('33000a63', render)
  })

}


export default __exports__